import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/VerifiedInstaller/VerifiedInstaller.js
const VerifiedInstaller = createSectionForm({
  icon: "verified-badge-line",
  title: "Verified Installer",
  fields: [
    { name: "title", label: "Title" },
    { name: "sticky_layout", label: "Sticky Left Column", type: "switch" },
    { name: "description", label: "Description", type: "richtext" },
    { name: "points_title", label: "Checklist Title", fullWidth: true },
    {
      name: "points",
      label: "Checklist",
      type: "list",
      itemLabel: "Point",
      fields: [{ name: "text", label: "Point" }],
    },
    { name: "trust_title", label: "Trust Title", fullWidth: true },
    {
      name: "trust_points",
      label: "Trust Points",
      type: "list",
      itemLabel: "Point",
      fields: [{ name: "text", label: "Point" }],
    },
    { name: "results_title", label: "Customer Results Title", fullWidth: true },
    {
      name: "results",
      label: "Customer Results",
      type: "list",
      itemLabel: "Result",
      fields: [
        { name: "quote", label: "Quote", type: "textarea" },
        { name: "author", label: "Author", placeholder: "Verified Customer" },
      ],
    },
  ],
});

export default VerifiedInstaller;
